import {
  Analytics,
  Assessment,
  CalendarMonth,
  DesktopWindows,
  Groups,
  PersonSearch,
  SportsScore,
} from "@mui/icons-material";

const FEATURE_DEFINITIONS = [
  {
    matches: ["estadísticas", "estadisticas"],
    title: "Estadísticas avanzadas",
    description: "Consulta rendimiento, comparativas e históricos deportivos.",
    icon: Analytics,
    route: "/estadisticasEquipos",
  },
  {
    matches: ["planificación", "planificacion"],
    title: "Planificación",
    description: "Organiza entrenamientos, partidos y planes semanales.",
    icon: CalendarMonth,
    route: "/planificacion",
  },
  {
    matches: ["informes", "informe"],
    title: "Informes de partido",
    description: "Prepara análisis de rivales y exportaciones profesionales.",
    icon: Assessment,
    route: "/partidos",
  },
  {
    matches: ["scouting"],
    title: "Scouting",
    description: "Sigue jugadores, observaciones y partidos de interés.",
    icon: PersonSearch,
    route: "/scouting",
  },
  {
    matches: ["live tag"],
    title: "Live Tag",
    description: "Registra y etiqueta eventos durante el partido.",
    icon: SportsScore,
    route: "/live-tag",
  },
  {
    matches: ["soccertycs client", "socceranalyticsclient", "cliente"],
    title: "Soccertycs Client",
    description: "Accede al flujo de vídeo y las herramientas de escritorio.",
    icon: DesktopWindows,
    route: "/cliente-windows",
  },
  {
    matches: ["gestión de equipos", "gestion de equipos"],
    pattern: /hasta\s+\d+\s+equipos?/,
    title: "Gestión de equipos",
    description: "Administra los equipos incluidos en la licencia.",
    icon: Groups,
    route: "/administrar-equipos",
  },
];

const normalize = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("es")
    .trim();

export const getOnboardingFeatures = (plan) => {
  const configuredFeatures = Array.isArray(plan?.features) ? plan.features : [];
  const resolved = [];

  configuredFeatures.forEach((featureName) => {
    const normalizedFeature = normalize(featureName);
    const definition = FEATURE_DEFINITIONS.find((feature) =>
      feature.matches.some((match) => normalizedFeature.includes(normalize(match)))
      || feature.pattern?.test(normalizedFeature)
    );
    if (definition && !resolved.some((feature) => feature.title === definition.title)) {
      resolved.push(definition);
    }
  });

  return resolved.slice(0, 6);
};

export const getTeamLimit = (plan) => {
  const limits = plan?.limits || {};
  return limits.max_managed_teams_per_season
    ?? limits.max_assigned_teams_per_season
    ?? null;
};

export const getOnboardingStorageKey = (userId, subscription) =>
  [
    "license_onboarding_completed",
    userId,
    subscription?.id,
    subscription?.plan_key,
  ].join(":");
